import { j as a } from "./atoms-v218.js";
import { ScreenReaderText as s } from "./atoms-v2733.js";
const x = ({ children: e, tagName: t = "span", ...r }) => /* @__PURE__ */ a.jsx(s, { as: t, "data-testid": "sr-only-text", ...r, children: e });
export {
  x as ScreenReaderText
};
